import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FhApplicationSetupService } from '@fh-client-interaction-frontends/fh-setup-service';

@Pipe({
  name: 'dynamicDate',
  pure: false
})
export class DynamicDatePipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private fhApplicationSetupService: FhApplicationSetupService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.fhApplicationSetupService.setup$.subscribe(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  transform(
    value: Date | string | number | null | undefined,
    format: string = 'mediumDate',
    timezone?: string
  ): string | null {
    const setup = this.fhApplicationSetupService.getCurrentSetup();
    if (!setup || !value) return null;

    const locale = setup.locale || 'pt-PT';
    return this.datePipe.transform(value, format, timezone, locale);
  }
}
